import {
  CdnPlanOption, fmtCount, fmtGb, planShare, planStatus, visiblePlans,
} from '../../utils/cdnPlan';
import styles from './CdnPlanTable.module.css';

const usd = (n: number) =>
  `${(n ?? 0) < 0 ? '−' : ''}$${Math.abs(n ?? 0).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const pct = (share: number) => `${share >= 0.1 || share === 0 ? Math.round(share * 100) : (share * 100).toFixed(1)}%`;

const STATUS_LABEL = { none: '', ok: 'Fits', near: 'Near the limit', over: 'Over the allowance' };

const CdnPlanTable = ({ options, current, recommended }: {
  options: CdnPlanOption[];
  current: string;
  recommended: string;
}) => (
  <div className={styles.scroll}>
    <table className={styles.table}>
      <thead>
        <tr>
          <th>Plan</th>
          <th>Price / month</th>
          <th>Allowance / month</th>
          <th>Covers</th>
          <th>Estimated use</th>
          <th title="Price minus the S3 Standard storage the plan's credit pays for">After S3 credit</th>
        </tr>
      </thead>
      <tbody>
        {visiblePlans(options, current, recommended).map((o) => {
          const status = planStatus(o);
          const share = planShare(o);
          return (
            <tr key={o.id} className={o.id === current ? styles.rowCurrent : undefined}>
              <td className={styles.strong}>
                {o.label}
                {o.id === current && <span className={styles.chipCurrent}>current</span>}
                {o.id === recommended && <span className={styles.chipRecommended}>recommended</span>}
              </td>
              <td>
                {o.id === 'payg'
                  ? <>{usd(o.monthlyUsd)}<span className={styles.sub}>at this traffic, no cap</span></>
                  : usd(o.usdMonthly)}
              </td>
              <td>
                {o.id === 'payg'
                  ? <>{fmtGb(o.gb)} + {fmtCount(o.requests)} req free<span className={styles.sub}>then per GB and per request</span></>
                  : <>{fmtCount(o.requests)} requests<span className={styles.sub}>{fmtGb(o.gb)} transfer</span></>}
              </td>
              <td>{o.sessions > 0 ? `≈ ${fmtCount(o.sessions)} sessions` : '—'}</td>
              <td>
                {status === 'none' ? (
                  <span className={styles.muted}>billed per use</span>
                ) : (
                  <div className={styles.usage}>
                    <div className={styles.meter} role="img" aria-label={`${pct(share)} of the allowance`}>
                      <span
                        className={`${styles.meterFill} ${styles[status]}`}
                        style={{ width: `${Math.min(100, share * 100)}%` }}
                      />
                    </div>
                    <span className={`${styles.status} ${styles[`${status}Text`]}`}>
                      {pct(share)} · {STATUS_LABEL[status]}
                    </span>
                    <span className={styles.sub}>
                      requests {pct(o.requestShare)} · data {pct(o.gbShare)}
                    </span>
                  </div>
                )}
              </td>
              <td>{usd(o.netUsd)}</td>
            </tr>
          );
        })}
      </tbody>
    </table>
  </div>
);

export default CdnPlanTable;
